import type { AttentionItem, AttentionSummary } from './types';

/** Visible counts cap at 99+; the accessible name always carries the exact count. */
export function formatCount(n: number): string {
  return n > 99 ? '99+' : String(n);
}

function joinLabels(items: AttentionItem[]): string {
  return items.map((i) => i.label).join(', ');
}

/** The tooltip and screen-reader text: the per-source labels. */
export function attentionSrText(summary: AttentionSummary): string {
  return joinLabels(summary.items);
}

/** "3 items need attention: <labels>", or '' when nothing needs attention. */
export function attentionTooltip(summary: AttentionSummary): string {
  if (summary.total === 0) return '';
  const lead = summary.total === 1 ? '1 item needs attention' : `${summary.total} items need attention`;
  return `${lead}: ${attentionSrText(summary)}`;
}

export function attentionAriaLabel(name: string, summary: AttentionSummary): string {
  if (summary.total === 0) return name;
  return `${name}, ${attentionTooltip(summary)}`;
}

export function attentionLabelsFor(summary: AttentionSummary, severity: 'warn' | 'danger'): string {
  return joinLabels(summary.items.filter((i) => i.severity === severity));
}
